import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { usePageTitle } from "@/lib/usePageTitle";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  usePageTitle("Reset your password — Olivia Does");

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(data.message || "Reset link sent.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md od-card p-8">
        <h1 className="font-display text-3xl">Reset your password</h1>
        {sent ? (
          <div data-testid="forgot-success" className="mt-6 rounded-lg border border-[#C97C8C]/30 bg-[#C97C8C]/10 text-[#2B2622] text-sm px-4 py-4">
            If an account exists for <span className="font-medium">{email}</span>, we've sent a link to reset your password. Please check your inbox (and spam folder).
          </div>
        ) : (
          <>
            <p className="text-sm text-[#78716C] mt-2">Enter your email and we'll send you a link to set a new password.</p>
            <form onSubmit={onSubmit} className="mt-8 space-y-4">
              <div>
                <Label className="text-xs uppercase tracking-widest text-[#78716C]">Email</Label>
                <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-xl border-[#E2DBD6]" />
              </div>
              <Button data-testid="forgot-submit" disabled={busy} type="submit" className="w-full rounded-full bg-[#2A2624] hover:bg-[#1E1A18] py-6">
                {busy ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          </>
        )}
        <p className="text-sm text-[#78716C] mt-6"><Link to="/login" className="od-link font-medium">Back to sign in</Link></p>
      </div>
    </div>
  );
}
